import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import s from './MonetizationPromoStrip.scss';
export const MonetizationPromoStrip = ({ monetizationPromo, className })=>{
    const { t } = useTranslation();
    if (![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable',
        'pcp',
        'generic'
    ].includes(monetizationPromo)) {
        return null;
    }
    let bodyKey;
    let badgePromo = monetizationPromo;
    if (monetizationPromo === 'tier') {
        bodyKey = 'avatar.monetizationPromoStrip.var.tier.body';
    } else {
        bodyKey = 'monetizationPromoStrip.var.generic.body';
        badgePromo = 'generic';
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: badgePromo,
        size: 24,
        className: s['badge']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(bodyKey))));
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';
export default MonetizationPromoStrip;

//# sourceMappingURL=MonetizationPromoStrip.js.map